export const translations = {
  en: {
    // Nav
    nav_home: "Home",
    nav_journal: "Journal",
    nav_voice: "Voice Entries",
    nav_mood: "Mood Tracker",
    nav_reflect: "AI Reflection",
    nav_insights: "AI Insights",
    nav_affirmations: "AI Affirmations",
    nav_discover: "Discover",
    nav_settings: "Settings",
    nav_signOut: "Sign Out",

    // Dashboard
    dash_goodMorning: "Good morning",
    dash_goodAfternoon: "Good afternoon",
    dash_goodEvening: "Good evening",
    dash_subtitle: "Take a moment. Breathe. This is your space.",
    dash_todaysReflection: "Today's Reflection",
    dash_writePlaceholder: "Write freely here…",
    dash_howFeeling: "How are you feeling? (select all that apply)",
    dash_saving: "Saving…",
    dash_saveReflection: "Save Reflection",
    dash_entrySaved: "Entry saved 🌿",
    dash_entrySavedDesc: "Your reflection has been recorded.",
    dash_writeJournal: "Write in Journal",
    dash_writeJournalDesc: "Explore your thoughts",
    dash_recordVoice: "Record Voice",
    dash_recordVoiceDesc: "Speak what's on your mind",
    dash_talkAI: "Talk to AI Guide",
    dash_talkAIDesc: "Get gentle support",
    dash_disclaimer: "This AI is a reflection tool, not a licensed therapist. If you are in crisis, please contact a mental health professional.",

    // Prompts
    prompt_1: "How are you feeling today?",
    prompt_2: "What is something that stayed with you today?",
    prompt_3: "Is there something you would like to process?",
    prompt_4: "What brought you comfort recently?",
    prompt_5: "What's on your mind right now?",

    // Journal
    journal_title: "Journal",
    journal_subtitle: "Your private space for written reflection.",
    journal_newEntry: "New Entry",
    journal_titlePlaceholder: "Entry title (optional)",
    journal_contentPlaceholder: "What's on your mind?",
    journal_cancel: "Cancel",
    journal_saving: "Saving…",
    journal_save: "Save Entry",
    journal_entrySaved: "Entry saved 🌿",
    journal_empty: "No entries yet",
    journal_emptyDesc: "Start writing to capture your thoughts.",
    journal_written: "Written",

    // Voice
    voice_title: "Voice Entries",
    voice_subtitle: "Speak your thoughts, let your voice be heard.",
    voice_tapToRecord: "Tap to Record",
    voice_recording: "Recording…",
    voice_stop: "Stop",
    voice_transcribe: "Transcribe",
    voice_transcribing: "Transcribing…",
    voice_transcriptionComplete: "Transcription complete ✨",
    voice_save: "Save Entry",
    voice_saving: "Saving…",
    voice_saved: "Voice entry saved 🎤",
    voice_discard: "Discard",
    voice_noEntries: "No voice entries yet",
    voice_noEntriesDesc: "Record your first voice entry above.",
    voice_viewTranscript: "View transcript",
    voice_hideTranscript: "Hide transcript",
    voice_noTranscript: "No transcript available.",

    // Mood Tracker
    mood_title: "Mood Tracker",
    mood_subtitle: "Track how you feel over time.",
    mood_distribution: "Mood Distribution",
    mood_timeline: "Recent Timeline",
    mood_noData: "No mood data yet",
    mood_noDataDesc: "Tag your journal entries with moods to see patterns.",

    // AI Reflection
    reflect_title: "Reflection Guide",
    reflect_subtitle: "Your supportive AI companion for emotional reflection.",
    reflect_shareMind: "Share what's on your mind",
    reflect_hereToListen: "I'm here to listen and help you reflect.",
    reflect_typePlaceholder: "Type your thoughts…",
    reflect_disclaimer: "This AI is a reflection tool, not a licensed therapist. Seek professional help for mental health concerns.",
    reflect_breathe: "Breathe",
    reflect_gentle: "Gentle Reflection",
    reflect_gentleDesc: "Warm, empathetic mirroring",
    reflect_guided: "Guided Journaling",
    reflect_guidedDesc: "Thoughtful prompts & questions",
    reflect_cognitive: "Cognitive Reframing",
    reflect_cognitiveDesc: "CBT-style perspective shifts",
    reflect_emotional: "Emotional Processing",
    reflect_emotionalDesc: "Feel and name your emotions",
    reflect_grounding: "Stress & Grounding",
    reflect_groundingDesc: "Anxiety relief & grounding",
    reflect_mindfulness: "Mindfulness Guidance",
    reflect_mindfulnessDesc: "Present-moment awareness",
    reflect_narrative: "Narrative Reframing",
    reflect_narrativeDesc: "Rewrite your story",

    // Breathing
    breathe_title: "Breathing Exercises",
    breathe_choosePattern: "Choose a breathing pattern to calm your mind before reflecting.",
    breathe_box: "Box Breathing",
    breathe_boxDesc: "Equal timing for calm focus",
    breathe_relaxation: "4-7-8 Relaxation",
    breathe_relaxationDesc: "Deep calm and sleep aid",
    breathe_calm: "Calm Breath",
    breathe_calmDesc: "Simple 5-second rhythm",
    breathe_in: "Breathe In",
    breathe_hold: "Hold",
    breathe_out: "Breathe Out",
    breathe_ready: "Ready",
    breathe_wellDone: "Well done ✨",
    breathe_takeAMoment: "Take a moment before you start reflecting.",
    breathe_start: "Start",
    breathe_stop: "Stop",
    breathe_repeat: "Repeat",
    breathe_continue: "Continue to Reflect",
    breathe_cycle: "Cycle",
    breathe_of: "of",

    // AI Insights
    insights_title: "AI Insights",
    insights_subtitle: "Patterns and progress from your reflections.",
    insights_discover: "Discover Your Patterns",
    insights_discoverDesc: "Our AI will gently analyze your journal entries to surface recurring emotions, potential triggers, and signs of growth. You'll need at least 3 entries.",
    insights_generate: "Generate Insights",
    insights_regenerate: "Regenerate",
    insights_analyzing: "Analyzing your journal entries…",
    insights_mayTakeMoment: "This may take a moment.",
    insights_overview: "Overview",
    insights_basedOn: "Based on",
    insights_entries: "entries",
    insights_previouslyGenerated: "previously generated",
    insights_recurringEmotions: "Recurring Emotions",
    insights_triggers: "Triggers & Influences",
    insights_growth: "Signs of Growth",
    insights_suggestion: "A Gentle Suggestion",
    insights_tryAgain: "Try Again",

    // Settings
    settings_title: "Settings",
    settings_subtitle: "Manage your account and privacy.",
    settings_privacy: "Privacy & Data",
    settings_privacyDesc: "Your journal entries, voice recordings, and AI conversations are private and encrypted. Only you can access your data.",
    settings_email: "Email",
    settings_deleteAll: "Delete All Data",
    settings_deleteAllDesc: "Permanently remove all your journal entries, AI conversations, and mood tracking data. This action cannot be undone.",
    settings_deleteConfirm: "Are you sure? This will permanently delete ALL your journal entries, AI conversations, and mood data. This cannot be undone.",
    settings_deleting: "Deleting…",
    settings_deleteBtn: "Delete All My Data",
    settings_deleted: "All data deleted",
    settings_deletedDesc: "Your data has been permanently removed.",
    settings_language: "Language",
    settings_languageDesc: "Choose your preferred language for the app interface.",

    // Moods
    mood_calm: "Calm",
    mood_anxious: "Anxious",
    mood_sad: "Sad",
    mood_overwhelmed: "Overwhelmed",
    mood_hopeful: "Hopeful",
    mood_reflective: "Reflective",
    mood_grateful: "Grateful",
    mood_happy: "Happy",
    mood_angry: "Angry",
    mood_energetic: "Energetic",
    mood_lonely: "Lonely",

    // Affirmations
    affirmations_title: "Today's Affirmations",
    affirmations_generating: "Creating your affirmations…",
    affirmations_noEntries: "Start journaling to receive personalized affirmations.",
    affirmations_aiNote: "Generated by AI based on your journal entries.",
    affirmations_rateLimit: "Too many requests. Please try again later.",
    affirmations_toggle: "AI Affirmations",
    affirmations_toggleDesc: "Receive personalized daily affirmations based on your journal entries.",
    weeklyRecap_toggle: "Sunday Recap Email",
    weeklyRecap_toggleDesc: "Get a gentle weekly summary of your entries, mood and streak — sent every Sunday.",
    affirmations_pageTitle: "AI Affirmations",
    affirmations_pageSubtitle: "Personalized daily words of encouragement based on your reflections.",

    // Install prompt
    install_title: "Make reflection a daily habit",
    install_description: "Add InnerPath to your home screen for quick, calm access anytime.",
    install_addButton: "Add to Home Screen",
    install_notNow: "Not now",
    install_iosSteps: "How to install",
    install_iosStep1: "Tap the Share icon",
    install_iosStep2: "Scroll down in the menu",
    install_iosStep3: "Tap \"Add to Home Screen\"",

    // Discover
    discover_title: "Discover",
    discover_subtitle: "Explore tools for your personal growth journey.",
    discover_spotlightTitle: "Feature Spotlight",
    discover_featureAffirmations: "AI Affirmations",
    discover_featureAffirmationsDesc: "Receive personalized affirmations generated from your journal entries.",
    discover_featureAffirmationsBtn: "See Today's Affirmations",
    discover_featureReflection: "AI Reflection",
    discover_featureReflectionDesc: "Have a gentle, supportive conversation with an AI guide about what's on your mind.",
    discover_featureReflectionBtn: "Start a Reflection",
    discover_featureInsights: "Mood Insights",
    discover_featureInsightsDesc: "Discover emotional patterns and growth signals from your journal entries.",
    discover_featureInsightsBtn: "View My Insights",
    discover_featureVoice: "Voice Journaling",
    discover_featureVoiceDesc: "Speak your thoughts out loud and let AI transcribe them into journal entries.",
    discover_featureVoiceBtn: "Record a Note",
    discover_promptsTitle: "Guided Journaling Prompts",
    discover_startWriting: "Start Writing",
    discover_prompt1: "What challenged you today?",
    discover_prompt2: "What are you proud of this week?",
    discover_prompt3: "What is something you are learning about yourself?",
    discover_prompt4: "What brought you comfort recently?",
    discover_prompt5: "What would you like to let go of?",
    discover_tipsTitle: "Emotional Growth Tips",
    discover_tip1Title: "Journaling Benefits",
    discover_tip1Desc: "Writing regularly helps reduce stress, improve mood, and strengthen self-awareness over time.",
    discover_tip2Title: "Reflection Exercises",
    discover_tip2Desc: "Spend 5 minutes each evening reviewing your day. Notice what went well and what you'd like to change.",
    discover_tip3Title: "Mindfulness Moments",
    discover_tip3Desc: "Pause before writing. Take three deep breaths. Let your thoughts settle before putting pen to paper.",
    discover_tryIt: "Try It",
    discover_notNow: "Not Now",
    discover_suggestAffirmations: "You haven't tried AI Affirmations yet",
    discover_suggestAffirmationsDesc: "Your journal entries can generate personalized daily affirmations to support your emotional wellbeing.",
    discover_suggestVoice: "Try Voice Journaling",
    discover_suggestVoiceDesc: "Sometimes speaking is easier than writing. Record your thoughts and let AI transcribe them.",
    discover_suggestReflect: "Have an AI Reflection",
    discover_suggestReflectDesc: "Talk through what's on your mind with a gentle, supportive AI companion.",
    discover_suggestMood: "Track Your Moods",
    discover_suggestMoodDesc: "Tag your journal entries with moods to discover emotional patterns over time.",
    discover_suggestInsights: "Discover Your Patterns",
    discover_suggestInsightsDesc: "AI can analyze your journal entries to reveal recurring emotions and signs of growth.",

    // Share
    share_title: "Share InnerPath",
    share_description: "Know someone who might benefit from journaling and reflection?",
    share_button: "Share the App",
    share_copied: "Link copied to clipboard ✨",

    // WhatsApp
    whatsapp_entry: "via WhatsApp",

    // Common
    error: "Error",
  },
  es: {
    // Nav
    nav_home: "Inicio",
    nav_journal: "Diario",
    nav_voice: "Notas de Voz",
    nav_mood: "Estado de Ánimo",
    nav_reflect: "Reflexión IA",
    nav_insights: "Perspectivas IA",
    nav_affirmations: "Afirmaciones IA",
    nav_discover: "Descubrir",
    nav_settings: "Configuración",
    nav_signOut: "Cerrar Sesión",

    // Dashboard
    dash_goodMorning: "Buenos días",
    dash_goodAfternoon: "Buenas tardes",
    dash_goodEvening: "Buenas noches",
    dash_subtitle: "Tómate un momento. Respira. Este es tu espacio.",
    dash_todaysReflection: "Reflexión de Hoy",
    dash_writePlaceholder: "Escribe libremente aquí…",
    dash_howFeeling: "¿Cómo te sientes? (selecciona todos los que apliquen)",
    dash_saving: "Guardando…",
    dash_saveReflection: "Guardar Reflexión",
    dash_entrySaved: "Entrada guardada 🌿",
    dash_entrySavedDesc: "Tu reflexión ha sido registrada.",
    dash_writeJournal: "Escribir en Diario",
    dash_writeJournalDesc: "Explora tus pensamientos",
    dash_recordVoice: "Grabar Voz",
    dash_recordVoiceDesc: "Di lo que tienes en mente",
    dash_talkAI: "Hablar con Guía IA",
    dash_talkAIDesc: "Recibe apoyo amable",
    dash_disclaimer: "Esta IA es una herramienta de reflexión, no un terapeuta con licencia. Si estás en crisis, por favor contacta a un profesional de salud mental.",

    // Prompts
    prompt_1: "¿Cómo te sientes hoy?",
    prompt_2: "¿Qué es algo que se quedó contigo hoy?",
    prompt_3: "¿Hay algo que te gustaría procesar?",
    prompt_4: "¿Qué te brindó consuelo recientemente?",
    prompt_5: "¿Qué tienes en mente ahora mismo?",

    // Journal
    journal_title: "Diario",
    journal_subtitle: "Tu espacio privado para la reflexión escrita.",
    journal_newEntry: "Nueva Entrada",
    journal_titlePlaceholder: "Título de la entrada (opcional)",
    journal_contentPlaceholder: "¿Qué tienes en mente?",
    journal_cancel: "Cancelar",
    journal_saving: "Guardando…",
    journal_save: "Guardar Entrada",
    journal_entrySaved: "Entrada guardada 🌿",
    journal_empty: "Aún no hay entradas",
    journal_emptyDesc: "Comienza a escribir para capturar tus pensamientos.",
    journal_written: "Escrito",

    // Voice
    voice_title: "Notas de Voz",
    voice_subtitle: "Habla tus pensamientos, deja que tu voz sea escuchada.",
    voice_tapToRecord: "Toca para Grabar",
    voice_recording: "Grabando…",
    voice_stop: "Detener",
    voice_transcribe: "Transcribir",
    voice_transcribing: "Transcribiendo…",
    voice_transcriptionComplete: "Transcripción completa ✨",
    voice_save: "Guardar Entrada",
    voice_saving: "Guardando…",
    voice_saved: "Nota de voz guardada 🎤",
    voice_discard: "Descartar",
    voice_noEntries: "Aún no hay notas de voz",
    voice_noEntriesDesc: "Graba tu primera nota de voz arriba.",
    voice_viewTranscript: "Ver transcripción",
    voice_hideTranscript: "Ocultar transcripción",
    voice_noTranscript: "Sin transcripción disponible.",

    // Mood Tracker
    mood_title: "Estado de Ánimo",
    mood_subtitle: "Rastrea cómo te sientes a lo largo del tiempo.",
    mood_distribution: "Distribución de Ánimo",
    mood_timeline: "Línea de Tiempo Reciente",
    mood_noData: "Aún no hay datos de ánimo",
    mood_noDataDesc: "Etiqueta tus entradas de diario con estados de ánimo para ver patrones.",

    // AI Reflection
    reflect_title: "Guía de Reflexión",
    reflect_subtitle: "Tu compañero IA de apoyo para la reflexión emocional.",
    reflect_shareMind: "Comparte lo que tienes en mente",
    reflect_hereToListen: "Estoy aquí para escucharte y ayudarte a reflexionar.",
    reflect_typePlaceholder: "Escribe tus pensamientos…",
    reflect_disclaimer: "Esta IA es una herramienta de reflexión, no un terapeuta con licencia. Busca ayuda profesional para problemas de salud mental.",
    reflect_breathe: "Respirar",
    reflect_gentle: "Reflexión Amable",
    reflect_gentleDesc: "Espejo cálido y empático",
    reflect_guided: "Diario Guiado",
    reflect_guidedDesc: "Preguntas y pautas reflexivas",
    reflect_cognitive: "Reestructuración Cognitiva",
    reflect_cognitiveDesc: "Cambios de perspectiva estilo TCC",
    reflect_emotional: "Procesamiento Emocional",
    reflect_emotionalDesc: "Siente y nombra tus emociones",
    reflect_grounding: "Estrés y Anclaje",
    reflect_groundingDesc: "Alivio de ansiedad y anclaje",
    reflect_mindfulness: "Guía de Mindfulness",
    reflect_mindfulnessDesc: "Conciencia del momento presente",
    reflect_narrative: "Reestructuración Narrativa",
    reflect_narrativeDesc: "Reescribe tu historia",

    // Breathing
    breathe_title: "Ejercicios de Respiración",
    breathe_choosePattern: "Elige un patrón de respiración para calmar tu mente antes de reflexionar.",
    breathe_box: "Respiración Cuadrada",
    breathe_boxDesc: "Tiempos iguales para enfoque tranquilo",
    breathe_relaxation: "Relajación 4-7-8",
    breathe_relaxationDesc: "Calma profunda y ayuda para dormir",
    breathe_calm: "Respiración Calma",
    breathe_calmDesc: "Ritmo simple de 5 segundos",
    breathe_in: "Inhala",
    breathe_hold: "Sostén",
    breathe_out: "Exhala",
    breathe_ready: "Listo",
    breathe_wellDone: "¡Bien hecho! ✨",
    breathe_takeAMoment: "Tómate un momento antes de comenzar a reflexionar.",
    breathe_start: "Iniciar",
    breathe_stop: "Detener",
    breathe_repeat: "Repetir",
    breathe_continue: "Continuar a Reflexionar",
    breathe_cycle: "Ciclo",
    breathe_of: "de",

    // AI Insights
    insights_title: "Perspectivas IA",
    insights_subtitle: "Patrones y progreso de tus reflexiones.",
    insights_discover: "Descubre Tus Patrones",
    insights_discoverDesc: "Nuestra IA analizará suavemente tus entradas de diario para revelar emociones recurrentes, posibles desencadenantes y señales de crecimiento. Necesitarás al menos 3 entradas.",
    insights_generate: "Generar Perspectivas",
    insights_regenerate: "Regenerar",
    insights_analyzing: "Analizando tus entradas de diario…",
    insights_mayTakeMoment: "Esto puede tomar un momento.",
    insights_overview: "Resumen",
    insights_basedOn: "Basado en",
    insights_entries: "entradas",
    insights_previouslyGenerated: "generado previamente",
    insights_recurringEmotions: "Emociones Recurrentes",
    insights_triggers: "Desencadenantes e Influencias",
    insights_growth: "Señales de Crecimiento",
    insights_suggestion: "Una Sugerencia Amable",
    insights_tryAgain: "Intentar de Nuevo",

    // Settings
    settings_title: "Configuración",
    settings_subtitle: "Administra tu cuenta y privacidad.",
    settings_privacy: "Privacidad y Datos",
    settings_privacyDesc: "Tus entradas de diario, grabaciones de voz y conversaciones con IA son privadas y encriptadas. Solo tú puedes acceder a tus datos.",
    settings_email: "Correo electrónico",
    settings_deleteAll: "Eliminar Todos los Datos",
    settings_deleteAllDesc: "Elimina permanentemente todas tus entradas de diario, conversaciones con IA y datos de estado de ánimo. Esta acción no se puede deshacer.",
    settings_deleteConfirm: "¿Estás seguro? Esto eliminará permanentemente TODAS tus entradas de diario, conversaciones con IA y datos de ánimo. No se puede deshacer.",
    settings_deleting: "Eliminando…",
    settings_deleteBtn: "Eliminar Todos Mis Datos",
    settings_deleted: "Todos los datos eliminados",
    settings_deletedDesc: "Tus datos han sido eliminados permanentemente.",
    settings_language: "Idioma",
    settings_languageDesc: "Elige tu idioma preferido para la interfaz de la aplicación.",

    // Moods
    mood_calm: "Calma",
    mood_anxious: "Ansiedad",
    mood_sad: "Tristeza",
    mood_overwhelmed: "Abrumado/a",
    mood_hopeful: "Esperanza",
    mood_reflective: "Reflexivo/a",
    mood_grateful: "Agradecido/a",
    mood_happy: "Feliz",
    mood_angry: "Enojado/a",
    mood_energetic: "Energético/a",
    mood_lonely: "Solo/a",

    // Affirmations
    affirmations_title: "Afirmaciones de Hoy",
    affirmations_generating: "Creando tus afirmaciones…",
    affirmations_noEntries: "Comienza a escribir en tu diario para recibir afirmaciones personalizadas.",
    affirmations_aiNote: "Generado por IA basado en tus entradas de diario.",
    affirmations_rateLimit: "Demasiadas solicitudes. Inténtalo más tarde.",
    affirmations_toggle: "Afirmaciones IA",
    affirmations_toggleDesc: "Recibe afirmaciones diarias personalizadas basadas en tus entradas de diario.",
    weeklyRecap_toggle: "Resumen del Domingo",
    weeklyRecap_toggleDesc: "Recibe cada domingo un resumen suave de tus entradas, ánimo y racha.",
    affirmations_pageTitle: "Afirmaciones IA",
    affirmations_pageSubtitle: "Palabras diarias de aliento personalizadas basadas en tus reflexiones.",

    // Install prompt
    install_title: "Haz de la reflexión un hábito diario",
    install_description: "Agrega InnerPath a tu pantalla de inicio para acceder rápida y calmadamente.",
    install_addButton: "Agregar a pantalla de inicio",
    install_notNow: "Ahora no",
    install_iosSteps: "Cómo instalar",
    install_iosStep1: "Toca el ícono de Compartir",
    install_iosStep2: "Desplázate hacia abajo en el menú",
    install_iosStep3: "Toca \"Agregar a pantalla de inicio\"",

    // Discover
    discover_title: "Descubrir",
    discover_subtitle: "Explora herramientas para tu camino de crecimiento personal.",
    discover_spotlightTitle: "Funciones Destacadas",
    discover_featureAffirmations: "Afirmaciones IA",
    discover_featureAffirmationsDesc: "Recibe afirmaciones personalizadas generadas a partir de tus entradas de diario.",
    discover_featureAffirmationsBtn: "Ver Afirmaciones de Hoy",
    discover_featureReflection: "Reflexión IA",
    discover_featureReflectionDesc: "Ten una conversación amable y de apoyo con un guía IA sobre lo que tienes en mente.",
    discover_featureReflectionBtn: "Iniciar una Reflexión",
    discover_featureInsights: "Perspectivas de Ánimo",
    discover_featureInsightsDesc: "Descubre patrones emocionales y señales de crecimiento en tus entradas de diario.",
    discover_featureInsightsBtn: "Ver Mis Perspectivas",
    discover_featureVoice: "Diario de Voz",
    discover_featureVoiceDesc: "Habla tus pensamientos en voz alta y deja que la IA los transcriba en entradas de diario.",
    discover_featureVoiceBtn: "Grabar una Nota",
    discover_promptsTitle: "Indicaciones de Diario Guiado",
    discover_startWriting: "Empezar a Escribir",
    discover_prompt1: "¿Qué te desafió hoy?",
    discover_prompt2: "¿De qué estás orgulloso/a esta semana?",
    discover_prompt3: "¿Qué es algo que estás aprendiendo sobre ti mismo/a?",
    discover_prompt4: "¿Qué te trajo consuelo recientemente?",
    discover_prompt5: "¿Qué te gustaría soltar?",
    discover_tipsTitle: "Consejos de Crecimiento Emocional",
    discover_tip1Title: "Beneficios del Diario",
    discover_tip1Desc: "Escribir regularmente ayuda a reducir el estrés, mejorar el ánimo y fortalecer la autoconciencia.",
    discover_tip2Title: "Ejercicios de Reflexión",
    discover_tip2Desc: "Dedica 5 minutos cada noche a revisar tu día. Nota lo que salió bien y lo que te gustaría cambiar.",
    discover_tip3Title: "Momentos de Mindfulness",
    discover_tip3Desc: "Haz una pausa antes de escribir. Toma tres respiraciones profundas. Deja que tus pensamientos se asienten.",
    discover_tryIt: "Probarlo",
    discover_notNow: "Ahora No",
    discover_suggestAffirmations: "Aún no has probado las Afirmaciones IA",
    discover_suggestAffirmationsDesc: "Tus entradas de diario pueden generar afirmaciones diarias personalizadas para apoyar tu bienestar emocional.",
    discover_suggestVoice: "Prueba el Diario de Voz",
    discover_suggestVoiceDesc: "A veces hablar es más fácil que escribir. Graba tus pensamientos y deja que la IA los transcriba.",
    discover_suggestReflect: "Ten una Reflexión IA",
    discover_suggestReflectDesc: "Habla sobre lo que tienes en mente con un compañero IA amable y de apoyo.",
    discover_suggestMood: "Rastrea Tus Estados de Ánimo",
    discover_suggestMoodDesc: "Etiqueta tus entradas de diario con estados de ánimo para descubrir patrones emocionales.",
    discover_suggestInsights: "Descubre Tus Patrones",
    discover_suggestInsightsDesc: "La IA puede analizar tus entradas de diario para revelar emociones recurrentes y señales de crecimiento.",

    // Share
    share_title: "Comparte InnerPath",
    share_description: "¿Conoces a alguien que se beneficiaría de escribir un diario y reflexionar?",
    share_button: "Compartir la App",
    share_copied: "Enlace copiado al portapapeles ✨",

    // WhatsApp
    whatsapp_entry: "vía WhatsApp",

    // Common
    error: "Error",
  },
} as const;

export type Language = keyof typeof translations;
export type TranslationKey = keyof typeof translations.en;
